(function () {
  var d = document;

  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) {
      var dlg = d.getElementById(o.getAttribute('data-open'));
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    var c = e.target.closest('[data-close-dlg]');
    if (c) {
      var parent = c.closest('dialog');
      if (parent) parent.close();
      return;
    }
    var t = e.target.closest('.thumb');
    if (!t) return;
    var m = d.querySelector('#mainPh img');
    if (m) {
      m.src = t.getAttribute('data-src');
      m.removeAttribute('srcset');
    }
  });

  var root = d.querySelector('[data-product]');
  var form = d.getElementById('pf');
  if (!root || !form) return;

  d.body.classList.add('pdp-page');

  var vs = JSON.parse(d.getElementById('variants').textContent);
  var fmt = new Intl.NumberFormat(d.documentElement.lang || 'en', {
    style: 'currency',
    currency: root.getAttribute('data-currency')
  });

  function selected() {
    return Array.prototype.map.call(form.querySelectorAll('.opt'), function (f) {
      var c = f.querySelector('input:checked');
      return c ? c.value : null;
    });
  }

  function update() {
    var s = selected();
    var v = vs.find(function (x) {
      return s.every(function (val, i) { return x['option' + (i + 1)] === val; });
    });
    var btn = d.getElementById('buy');
    if (!v) {
      btn.disabled = true;
      btn.textContent = root.getAttribute('data-unavailable');
      return;
    }
    d.getElementById('vid').value = v.id;
    d.getElementById('price').textContent = fmt.format(v.price / 100);
    d.getElementById('price2').textContent = fmt.format(v.price / 100);
    var was = d.getElementById('was');
    if (was) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        was.hidden = false;
        was.textContent = fmt.format(v.compare_at_price / 100);
      } else {
        was.hidden = true;
      }
    }
    btn.disabled = !v.available;
    btn.textContent = v.available ? root.getAttribute('data-add') : root.getAttribute('data-sold');
    d.getElementById('buy2').disabled = !v.available;
    var fi = v.featured_image && v.featured_image.src;
    var mainImg = d.querySelector('#mainPh img');
    if (fi && mainImg) {
      mainImg.src = fi;
      mainImg.removeAttribute('srcset');
    }
    try { history.replaceState(null, '', '?variant=' + v.id); } catch (err) {}
  }

  form.addEventListener('change', update);
  d.getElementById('buy2').addEventListener('click', function () {
    if (!d.getElementById('buy').disabled) form.requestSubmit();
  });
})();
